














import Vue from "vue";
import BaseSpinner from "@/components/BaseSpinner";

export default Vue.extend({
  name: "MoreMenuStats",
  components: { BaseSpinner },
  props: {
    loading: { type: Boolean, required: true },
    followersCount: { type: Number, required: true },
    subscribersCount: { type: Number, required: true },
  },
});
